// extracted by mini-css-extract-plugin
module.exports = {"app__icon":"style_app__icon__zZZ7r","app__icon__link":"style_app__icon__link__3yNGr","app__icon__letter":"style_app__icon__letter__2oe1l"};